<div class="d-flex justify-content-between text-nowrap align-items-center">
    <label class="d-inline-block  mb-0">{{label}}</label>
    <input style="max-width: 100px" class="form-control" [value]="subscription.value ? subscription.value : '-'"  (change)="change($event)">
</div>